export const fmtCurrency = (amount: number, currency: string = 'ARS', locale: string = 'es-AR'): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(amount);
};

export const slugify = (text: string): string => {
  return text
    .toString()
    .normalize('NFD') // Normalize to decompose accented characters
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
    .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
};

export const generateSlug = (title: string): string => {
  return slugify(title);
};

export const formatDate = (date: Date, locale: string = 'es-AR'): string => {
  return new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'long', day: 'numeric' }).format(date);
};

export const formatDateRelative = (date: Date, locale: string = 'es-AR'): string => {
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) {
    return 'hace unos segundos';
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `hace ${minutes} minuto${minutes > 1 ? 's' : ''}`;
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `hace ${hours} hora${hours > 1 ? 's' : ''}`;
  } else {
    const days = Math.floor(diffInSeconds / 86400);
    return `hace ${days} día${days > 1 ? 's' : ''}`;
  }
};

export const formatPhoneNumber = (phone: string, locale: string = 'es-AR'): string => {
  // Simple formatting for Argentine phone numbers
  return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
};

export const formatEmail = (email: string): string => {
  return email.toLowerCase();
};

export const formatAddress = (address: string): string => {
  return address.trim();
};

export const formatSocialLink = (platform: string, url: string): { platform: string; url: string } => {
  return { platform, url };
};

export const formatFAQLink = (question: string, link: string): { question: string; link: string } => {
  return { question, link };
};

export const slugifyTitle = (title: string): string => {
  return slugify(title);
};
